import React, { ReactNode } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import env from '../../env';

const oktaAuth = new OktaAuth(env.oidc);

const restoreOriginalUri = async (_oktaAuth: any, originalUri: string): Promise<void> => {
  window.location.replace(originalUri);
};

const LariSecurity = ({ children }: { children: ReactNode }) => (
  <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
    {children}
  </Security>
);

export default LariSecurity;
